module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/btn-portuguesse-playlist.e4f41690.png";